<span
    *ngIf="status"
    class="label"
    [ngClass]="{
        'label-danger': status === 'Expired',
        'label-warning': status === 'Expiring',
        'label-success': status === 'Valid',
    }">
    {{ status }} {{ status !== 'Valid' ? cardExpiryNextFriendly : '' }}
</span>
